import React from 'react'
import { twMerge } from 'tailwind-merge'

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12',
}

function LoadingSpinner({ size = 'md', className, label = 'Loading' }) {
  const classes = twMerge(
    'animate-spin rounded-full border-4 border-primary-600 border-t-transparent',
    sizeClasses[size],
    className
  )
  return (
    <div role="status" aria-label={label} className="inline-flex">
      <div className={classes} />
      <span className="sr-only">{label}</span>
    </div>
  )
}

export default LoadingSpinner
